import { useTranslation } from 'react-i18next'
import { Link, useParams } from '@tanstack/react-router'
import { useRecipe } from './useRecipe'
import { useUpdateRecipe } from './useUpdateRecipe'
import { RecipeForm } from './RecipeForm'
import type { RecipeFormData } from './types'

export function RecipeEditPage() {
  const { recipeId } = useParams({ strict: false }) as { recipeId: string }
  const { t } = useTranslation('recipes')
  const { data: recipe, isLoading } = useRecipe(recipeId)
  const { mutate, isPending } = useUpdateRecipe(recipeId)

  if (isLoading) {
    return (
      <div className="px-4 pt-4 pb-24 space-y-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-8 rounded-lg bg-surface animate-pulse" />
        ))}
      </div>
    )
  }

  if (!recipe) return null

  const defaultValues: RecipeFormData = {
    name: recipe.name,
    servingSize: recipe.servingSize,
    method: recipe.method,
    ingredients: recipe.ingredients.map((ing) => ({
      ingredientId: ing.ingredientId,
      ingredientName: ing.ingredientName,
      canonicalUnit: ing.canonicalUnit,
      quantity: ing.quantity,
      unit: ing.unit,
    })),
  }

  return (
    <div className="px-4 pt-4 pb-24">
      <div className="flex items-center gap-3 mb-4">
        <Link
          to="/recipes/$recipeId"
          params={{ recipeId }}
          className="text-sm text-muted hover:text-ink min-h-[44px] flex items-center"
        >
          ←
        </Link>
        <h1 className="text-xl font-bold text-ink">{t('edit.title')}</h1>
      </div>
      <RecipeForm onSubmit={mutate} isPending={isPending} defaultValues={defaultValues} />
    </div>
  )
}
